import { createSlice } from "@reduxjs/toolkit";

const pendingTransactionSlice = createSlice({
  name: "transaction",
  initialState: {
    isProcessing: false,
    error: false,
    checkId: [],
    Id: null,
    message: false,
    reversalMessage: null,
    transHistory: [],
    charges: [],
    reversedTransHistory: [],
    inprogressTransHistory: [],
    pendingTrans: [],
    generalMarket: [],
  },
  reducers: {
    getTransHistoryStart: (state) => {
      state.isProcessing = true;
    },
    getTransHistorySucess: (state, action) => {
      state.isProcessing = false;
      state.transHistory = action.payload;
    },
    getTransHistoryFailure: (state) => {
      state.isProcessing = false;
      state.error = true;
    },
    getChargesStart: (state) => {
      state.isProcessing = true;
    },
    getChargesSucess: (state, action) => {
      state.isProcessing = false;
      state.charges = action.payload;
    },
    getCharges: (state) => {
      state.isProcessing = false;
      state.error = true;
    },
    getReversedTransHistoryStart: (state) => {
      state.isProcessing = true;
    },
    getReversedTransHistorySucess: (state, action) => {
      state.isProcessing = false;
      state.reversedTransHistory = action.payload;
    },
    getReversedTransHistoryFailure: (state) => {
      state.isProcessing = false;
      state.error = true;
    },
    getInprogressTransHistoryStart: (state) => {
      state.isProcessing = true;
    },
    getInprogressTransHistorySucess: (state, action) => {
      state.isProcessing = false;
      state.inprogressTransHistory = action.payload;
    },
    getInprogressTransHistoryFailure: (state) => {
      state.isProcessing = false;
      state.error = true;
    },
    getPendingTransStart: (state) => {
      state.isProcessing = true;
      state.error = false;
    },
    getPendingTransSucess: (state, action) => {
      state.isProcessing = false;
      state.pendingTrans = action.payload;
      state.error = false;
    },
    getPendingTransFailure: (state) => {
      state.isProcessing = false;
      state.error = true;
    },
    getGmStart: (state) => {
      state.isProcessing = true;
    },
    getGmSucess: (state, action) => {
      state.isProcessing = false;
      state.generalMarket = action.payload;
    },
    getGmFailure: (state) => {
      state.isProcessing = false;
      state.error = true;
    },
    reProcessAllStart: (state) => {
      state.isProcessing = true;
    },
    reProcessAllSucess: (state, action) => {
      state.isProcessing = false;
      state.checkId = action.payload;
      state.message = true;
      state.error = false;
    },
    id: (state) => {
      state.checkId = [];
    },
    reProcessAllFailure: (state) => {
      state.isProcessing = false;
      state.error = true;
    },
    deliveredAllStart: (state) => {
      state.isProcessing = true;
    },
    deliveredAllSucess: (state, action) => {
      state.isProcessing = false;
      state.checkId = action.payload;
      state.message = true;
      state.error = false;
    },

    deliveredAllFailure: (state) => {
      state.isProcessing = false;
      state.error = true;
    },
    reversalAllStart: (state) => {
      state.isProcessing = true;
      state.error = false;
    },
    reversalAllSucess: (state, action) => {
      state.isProcessing = false;
      state.checkId = action.payload;
      state.message = true;
      state.error = false;
    },
    reversalAllFailure: (state) => {
      state.isProcessing = false;
      state.error = true;
    },

    reProcessOneStart: (state) => {
      state.isProcessing = true;
    },
    reProcessOneSucess: (state, action) => {
      state.isProcessing = false;
      state.Id = action.payload;
      state.message = true;
      state.error = false;
    },
    reProcessOneFailure: (state) => {
      state.isProcessing = false;
      state.error = true;
    },
    deliveredOneStart: (state) => {
      state.isProcessing = true;
    },
    deliveredOneSucess: (state, action) => {
      state.isProcessing = false;
      state.Id = action.payload;
      state.message = true;
      state.error = false;
    },
    deliveredOneFailure: (state) => {
      state.isProcessing = false;
      state.error = true;
    },
    reversalOneStart: (state) => {
      state.isProcessing = true;
    },
    reversalOneSucess: (state, action) => {
      state.isProcessing = false;
      state.Id = action.payload;
      state.message = true;
      state.error = false;
    },
    reversalOneFailure: (state) => {
      state.isProcessing = false;
      state.error = true;
    },
    toggleCheckbox: (state, action) => {
      const id = action.payload;
      const isChecked = state.checkId.includes(id);

      if (isChecked) {
        state.checkId = state.checkId.filter((checkedId) => checkedId !== id);
      } else {
        state.checkId.push(id);
        state.error = false;
      }
    },
    emptyCheckbox: (state) => {
      state.error = true;
    },
    clearMessage: (state) => {
      state.message = null;
      state.reversalMessage = null;
    },
    clearError: (state) => {
      state.error = false;
    },
  },
});

export const {
  reProcessAllStart,
  reProcessAllSucess,
  reProcessAllFailure,
  deliveredAllStart,
  deliveredAllSucess,
  deliveredAllFailure,
  reversalAllStart,
  reversalAllSucess,
  reversalAllFailure,
  getTransHistoryStart,
  getTransHistorySucess,
  getTransHistoryFailure,
  getChargesStart,
  getChargesSucess,
  getChargesFailure,
  getReversedTransHistoryStart,
  getReversedTransHistorySucess,
  getReversedTransHistoryFailure,
  getInprogressTransHistoryStart,
  getInprogressTransHistorySucess,
  getInprogressTransHistoryFailure,
  getPendingTransStart,
  getPendingTransSucess,
  getPendingTransFailure,
  toggleCheckbox,
  emptyCheckbox,
  getGmStart,
  getGmSucess,
  getGmFailure,
  reProcessOneStart,
  reProcessOneSucess,
  reProcessOneFailure,
  deliveredOneStart,
  deliveredOneSucess,
  deliveredOneFailure,
  reversalOneStart,
  reversalOneSucess,
  reversalOneFailure,
  clearError,
  clearMessage,
  id,
} = pendingTransactionSlice.actions;
export default pendingTransactionSlice.reducer;
